import { render, staticRenderFns } from "./PageMeusArquivos.vue?vue&type=template&id=b763356e&scoped=true&"
import script from "./PageMeusArquivos.vue?vue&type=script&lang=js&"
export * from "./PageMeusArquivos.vue?vue&type=script&lang=js&"
import style0 from "./PageMeusArquivos.vue?vue&type=style&index=0&id=b763356e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b763356e",
  null
  
)

export default component.exports